import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { resetAllSteps } from 'actions/stages';
import FormHeader from 'components/FormHeader';
import ErrorIcon from 'components/Icons/ErrorIcon';
import styles from 'pages/Error/Error.module.scss';

const Error = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Oops. An error has occurred.</h1>
          <ErrorIcon className={styles.errorIcon} />
        </div>
      </FormHeader>
    </>
  );
};

export default Error;
